import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'
import _imports_1 from '@/app/ui/assets/svg/plus-active.svg'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-wrap flex-row bg-gray-lp-700 p-4 rounded w-14/20\"><div class=\"w-1/12 font-semibold text-12px xxl:text-14px\">Tier</div><div class=\"w-4/12 font-semibold text-12px xxl:text-14px\"> Minimum Top Up <span class=\"text-red-lp-300 font-normal pl-1\">*</span></div><div class=\"w-4/12 font-semibold text-12px xxl:text-14px\"> Maksimum Top Up <span class=\"text-red-lp-300 font-normal pl-1\">*</span></div><div class=\"w-3/12 font-semibold text-12px xxl:text-14px\"> Cashback <span class=\"text-red-lp-300 font-normal pl-1\">*</span></div></div>", 1)
const _hoisted_2 = { class: "w-1/12" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "w-4/12 flex flex-row" }
const _hoisted_5 = { class: "w-10/12" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "p-4 pl-6" }, "<", -1)
const _hoisted_7 = { class: "w-4/12" }
const _hoisted_8 = { class: "w-10/12" }
const _hoisted_9 = { class: "w-2/12" }
const _hoisted_10 = { class: "w-10/12" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "x"
}, null, -1)
const _hoisted_12 = { class: "flex flex-row justify-between py-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "plus active"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Tier ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Title, {
      label: "Perhitungan Tier",
      class: "text-20px"
    }),
    _hoisted_1,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.ccbTiers, (config, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: "flex flex-wrap flex-row items-start pb-6 border-b border-dashed w-14/20"
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("p", _hoisted_3, _toDisplayString(index + 1), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_lp_input, _mergeProps({
              "error-icon": false,
              modelValue: config.min_balance,
              "onUpdate:modelValue": ($event: any) => (config.min_balance = $event),
              format: _ctx.formatTiers,
              prefix: "Rp",
              disabled: index > 0,
              disableBackground: ""
            }, _ctx.isErrorMinTopUp(index)), null, 16, ["modelValue", "onUpdate:modelValue", "format", "disabled"])
          ]),
          _hoisted_6
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_lp_input, _mergeProps({
              "error-icon": false,
              format: _ctx.formatTiers,
              modelValue: config.max_balance,
              "onUpdate:modelValue": ($event: any) => (config.max_balance = $event),
              onChange: (val) => _ctx.changeMaxTopUp(val, index),
              prefix: "Rp"
            }, _ctx.isErrorMaxTopUp(index)), null, 16, ["format", "modelValue", "onUpdate:modelValue", "onChange"])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_lp_input, _mergeProps({
              "error-icon": false,
              format: _ctx.formatDecimal,
              modelValue: config.percentage,
              "onUpdate:modelValue": ($event: any) => (config.percentage = $event),
              suffix: "%"
            }, _ctx.isErrorPercentage(index)), null, 16, ["format", "modelValue", "onUpdate:modelValue"])
          ])
        ]),
        _withDirectives(_createVNode("div", {
          onClick: ($event: any) => (_ctx.removeTiers(index)),
          class: "self-center cursor-pointer ml-3 relative"
        }, [
          _hoisted_11
        ], 8, ["onClick"]), [
          [_vShow, _ctx.ableToRemoveTierss]
        ])
      ]))
    }), 128)),
    _withDirectives(_createVNode("div", _hoisted_12, [
      _createVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addTiers && _ctx.addTiers(...args))),
        class: "cursor-pointer flex gap-3 text-red-lp-300"
      }, [
        _hoisted_13,
        _hoisted_14
      ])
    ], 512), [
      [_vShow, _ctx.ableToAddTierss]
    ])
  ], 64))
}